import { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { FETCH_GLOBAL_DELIVERY_DAYS, selectGlobalDeliveryDays } from '../../stores/order'

export function useGlobalDeliveryDays() {
  const dispatch = useDispatch()
  const globalDeliveryDays = useSelector(selectGlobalDeliveryDays)

  useEffect(() => {
    dispatch(FETCH_GLOBAL_DELIVERY_DAYS.request())
  }, [dispatch])

  return globalDeliveryDays
}
